import { gql } from '@apollo/client';

export const fetchShipToInPPC = gql`
  query fetchShipToInPPC($searchParams: ShipToPartySearchParams, $pageParams: ShipToPartyPageParams) {
    shipToParty(searchParams: $searchParams, pageParams: $pageParams) {
      totalCount
      nodes {
        name
        id
        addressLine1
        addressLine2
        city
        state
        country
        postcode
        priceEligibility
        taxId
        taxIds {
          id
          label
          metadata {
            vatStatus
          }
          taxExempt
        }
        taxLabels {
          region
          taxIdLabels {
            description
            displayName
            type
            metadata {
              type
              labels {
                default
                label
                vatStatus
              }
            }
          }
        }
        taxExempt
        hasLinkedSubscriptions
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;
